export default {"src":"/_next/static/media/dnt.e6537a93.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};